import { Typography } from "@mui/material";
import { useState } from "react";
import CopySnackbar from "src/components/common/CopySnackbar";
/**
 * @param {string} props.text - Text to be copied
 * @param {JSX.Element} props.children - Optional component to be rendered
 * @returns {JSX.Element} Copy handled wrapped component
 */
export default function CopyOnClick(props: { text: string; children?: JSX.Element }) {
  const [open, setOpen] = useState(false);

  const copyToClipboard = () => {
    // end function if false
    if (!window.isSecureContext) {
      return;
    }
    navigator.clipboard.writeText(props.text);
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 1500);
  };

  return (
    <>
      {props.children ? (
        <div onClick={copyToClipboard} style={{ cursor: "copy" }}>
          <CopySnackbar open={open} handleClose={setOpen} />
          {props.children}
        </div>
      ) : (
        <div style={{ cursor: "copy" }}>
          <CopySnackbar open={open} handleClose={setOpen} />
          <Typography onClick={copyToClipboard}>{props.text}</Typography>
        </div>
      )}
    </>
  );
}
